import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useCreateTimeOff } from "@/features/calendar/hooks/use-timeoffs";
import { CalendarX } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "@/features/utils/i18n";
import { toast } from "sonner";
import { TimeOffForm } from "./timeoff-form";

export const TimeOffDialog = () => {
  const { t } = useTranslation("schedules");
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [affectedMemberIds, setAffectedMemberIds] = useState<string[]>([]);

  const createTimeOff = useCreateTimeOff();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await createTimeOff.mutateAsync({
        reason,
        start_date: startDate,
        end_date: endDate,
        affected_members: { id: affectedMemberIds },
      });

      toast.success(t("closures.messages.created"));
      setOpen(false);
      // Reset form
      setReason("");
      setStartDate("");
      setEndDate("");
      setAffectedMemberIds([]);
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : t("closures.messages.createError"),
      );
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <CalendarX className="h-4 w-4 mr-2" />
          {t("closuresSection.add")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("closures.createDialog.title")}</DialogTitle>
          <DialogDescription>
            {t("closures.createDialog.description")}
          </DialogDescription>
        </DialogHeader>

        <TimeOffForm
          reason={reason}
          startDate={startDate}
          endDate={endDate}
          affectedMemberIds={affectedMemberIds}
          onReasonChange={setReason}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onAffectedMembersChange={setAffectedMemberIds}
          onSubmit={handleSubmit}
          onCancel={() => setOpen(false)}
          submitLabel={t("closures.form.add")}
          isSubmitting={createTimeOff.isPending}
        />
      </DialogContent>
    </Dialog>
  );
};
